<div class="cursor-pointer" [ngClass]="{'pointer-events-none': isWorkflow}">
  <finxone-web-frontend-cancel-payments-info
    [contentStyle]="contentStyle"
    [selectedTextStyleClass]="selectedTextStyleClass"
    [colorTextAlignStyle]="colorTextAlignStyle"
    [renderedContent]="renderedContent"
    (actionClick)="onActionClick()"
  ></finxone-web-frontend-cancel-payments-info>
</div>
